// #################################

// Разработано на: RISE PROJECT
// Разработчик: WOTKAD
// Сайт: WOTKAD.RU
// Сайт проекта: WOTKAD.RU/RISE

// #################################

import "./base/common/preloader";
import "./base/common/smooth-scroll";
import "./base/common/scroll-reveal";

import "./base/checks/check-internal-links";
import "./base/checks/check-target";
import "./base/common/get-current-year";
import "./base/common/get-header-height";
import "./base/common/get-footer-height";

import "./components/toggle/toggle-search";
import "./components/toggle/toggle-menu";
import "./components/toggle/toggle-filters";
import "./components/toggle/toggle-cart-popup";
import "./components/toggle/toggle-product-info";
import "./components/toggle/toggle-popups";
import "./components/toggle/toggle-favorite";
import "./components/toggle/toggle-profile-order";
import "./components/toggle/toggle-pass-type";

import "./components/slider/slider-hero";
import "./components/slider/slider-products";
import "./components/slider/slider-brands";
import "./components/slider/slider-blog-categories";
import "./components/slider/slider-blog-main";
import "./components/slider/slider-recommended";
import "./components/slider/slider-product";
import "./components/slider/slider-search";
import "./components/slider/slider-collaboration";

import "./components/scroll/scroll-header";
import "./components/scroll/scroll-cart-popup";

import "./components/form/sendFormCheckout";
import "./components/form/sendFormPopup";
import "./components/form/sendMail";
import "./components/form/sendFormPromocode";

import "./components/cart/cart-items";

import "./components/timer";
